import { createApi } from '@/api/modules/utils'

const baseUrl = '/core_word'
const api = createApi(baseUrl)

// 业务核心词
export const coreWordApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get')
}
